var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHomeBankingAndPaymentsAssignTransaction(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "32px",
    height: "32px",
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Basics",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Basics/Icons",
    transform: "translate(-4262.000000, -1844.000000)",
    fill: "#262626"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Home-banking-and-payments/Assign-transaction",
    transform: "translate(4262.000000, 1844.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M26.6421507,11.9154096 L32,18.9567189 L26.6421507,26 L6.99970313,26 L6.99970313,19.8026225 L17.4994078,19.8026225 L18.099391,19.0139012 L22.5992644,13.0994775 L23.4992391,11.9154096 L26.6421507,11.9154096 Z M16.499536,6 L20.9994094,11.9154096 L16.499536,17.8308193 L0,17.8308193 L0,6 L16.499536,6 Z M8.38276423,7.97180321 L6.99980313,9.33629104 L11.6596721,13.9296066 L9.12974323,13.9296066 C8.0497736,13.9296066 7.17379824,14.7932564 7.17379824,15.8590161 L7.17379824,15.8590161 L14.9995781,15.8590161 L14.9995781,8.14335009 C13.9186085,8.14335009 13.0426332,9.0069999 13.0426332,10.0717736 L13.0426332,10.0717736 L13.0426332,12.5661047 L8.38276423,7.97180321 Z",
    id: 94
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeBankingAndPaymentsAssignTransaction);
export default __webpack_public_path__ + "static/media/home-banking-and-payments-assign-transaction.e105cc7d.svg";
export { ForwardRef as ReactComponent };